module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "lxm-login__logo-text"
  }, [_vm._v("每个智慧公益背后都有灵析")]), _vm._v(" "), _c('div', {
    staticClass: "lxm-login__container"
  }, [_c('input-align-left', {
    attrs: {
      "type": 'email',
      "placeholder": '请输入您的邮箱',
      "value": _vm.email,
      "error": _vm.state.emailError,
      "transparent": true
    },
    on: {
      "input": _vm.emailChanged,
      "click": _vm.emailClicked
    }
  }), _vm._v(" "), _c('input-align-left', {
    attrs: {
      "type": 'password',
      "placeholder": '请输入您的密码',
      "value": _vm.loginPassword,
      "transparent": true,
      "error": _vm.state.loginPasswordError
    },
    on: {
      "input": _vm.loginPasswordChanged,
      "click": _vm.loginPasswordClicked
    }
  }), _vm._v(" "), _c('button-primary', {
    staticClass: "lxm-login-login-email__button-primary",
    attrs: {
      "text": '登录',
      "loading": _vm.buttonLoading
    },
    on: {
      "click": _vm.clicked
    }
  }), _vm._v(" "), _c('other-button')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-login__logo"
  }, [_c('img', {
    attrs: {
      "src": "https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9b82040a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b82040a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginEmail.vue
// module id = 882
// module chunks = 0